import React, {useState} from "react";
import styles from "./styles.scss";
import IconComponent from "../../../../components/commons/IconComponent";
import {connect} from "react-redux";
import {addMagazine, toggleToaster} from "../../../../store/actions";
import {getTranslation} from "../../../../store/getters";
import {MagazinesResource} from "../../../../resources";
import MagazineSizeDropdown from "../MagazineSizeDropdown";
import {defaultPageSize} from "../../../../utils/pageSize";

function MagazineCreateNewButton({translation, addMagazine, toggleToaster}) {
    const [loading, setLoading] = useState(false);
    const [isDropdownOpened, setIsDropdownOpened] = useState(false);

    const onClickCreateNew = async (pageSize) => {
        try {
            setLoading(true);
            setIsDropdownOpened(false);
            const {data: magazine} = await MagazinesResource.save({
                title: "\0",
                description: "",
                properties: JSON.stringify({
                    pageSize: pageSize,
                    backgroundColor: "#c4d1e0",
                }),
            });
            addMagazine(magazine);
            notify("success", translation("general-magazine-create-success"));
            openEditor(magazine);
        } catch (e) {
            notify("error", e.toString());
        } finally {
            setLoading(false);
        }
    };

    const openEditor = magazine => {
        const anchor = document.createElement("a");
        anchor.href = `/magazines/${magazine.id}`;
        anchor.target = "_blank";
        anchor.click();
    };

    const notify = (type, message) => {
        toggleToaster({
            isVisible: true,
            position: "top-right",
            message, type,
        });
    };

    const onClickOpenDropdown = () => setIsDropdownOpened(true);

    const onClickCloseDropdown = () => setIsDropdownOpened(false);

    return (
        <div className={styles.container}>
            <div className={styles.group}>
                <button id="create-magazine-btn" className={styles.btn} disabled={loading}
                        onClick={() => onClickCreateNew(defaultPageSize)}>
                    {translation("magazine-new-magazine")}
                </button>
                <button className={`${styles.icon} ${isDropdownOpened && styles.isActive}`}
                        disabled={loading} onClick={onClickOpenDropdown}>
                    <IconComponent icon="button-select-inactive"/>
                </button>
            </div>
            {isDropdownOpened &&
                <>
                    <div className={styles.backdrop} onClick={onClickCloseDropdown}/>
                    <div className={styles.dropdown}>
                        <MagazineSizeDropdown onClick={onClickCreateNew}/>
                    </div>
                </>
            }
        </div>
    );
}

export default connect(state => {
    const translation = getTranslation(state);

    return {translation};
}, {
    toggleToaster,
    addMagazine,
})(MagazineCreateNewButton);


// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineCreateNewButton/index.js